/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Empty_DayInputs */



/**
* | output |
* | --- |
* | "No meetings planned." |
*
* @param {Agenda_Empty_DayInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_empty_day = /** @type {((inputs?: Agenda_Empty_DayInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Empty_DayInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Geen meetings gepland.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune réunion prévue.")
	return /** @type {LocalizedString} */ ("No meetings planned.")
});